export default __webpack_public_path__ + "static/media/logoPartner.42a1d7e6.svg";